import { Injectable } from '@angular/core';
import { filter, fromEvent, map, Observable, scan, takeUntil } from 'rxjs';
import { StoreService } from './store.service';

@Injectable({
	providedIn: 'root',
})
export class BarcodeService {
	constructor(private _ss: StoreService) {}

	barcodePrefixCharacter = '*';
	barcodeSuffixCharacter = '*';

	updateCharacters() {
		if (!this._ss.CustomerInformation) {
			return;
		}

		this.barcodePrefixCharacter = this._ss.CustomerInformation.BarcodePrefixCharacter || this.barcodePrefixCharacter;

		this.barcodeSuffixCharacter = this._ss.CustomerInformation.BarcodeSuffixCharacter || this.barcodeSuffixCharacter;
	}

	createBarcodeStream(): Observable<string> {
		return fromEvent<KeyboardEvent>(window, 'keydown').pipe(
			filter(e => !(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement)),
			scan(
				(acc, { key }) => {
					// ignore android case where shift is sent before a capital letter, like typing on a keyboard
					if (key.toLowerCase() === 'shift') return acc;
					if (!acc.done) {
						if (key === this.barcodePrefixCharacter && !acc.capture) {
							return { capture: true, keys: '', done: false };
						}
						if (key === this.barcodeSuffixCharacter && acc.capture) {
							return { capture: false, keys: acc.keys, done: true };
						}
					}
					if (acc.capture) {
						return { capture: true, keys: acc.keys + key, done: false };
					}
					return acc;
				},
				{ capture: false, keys: '', done: false },
			),
			filter(({ capture, done }) => !capture && done),
			map(acc => {
				acc.done = false;
				return acc.keys;
			}),
		);
	}

	// This is the refactored version of the above function
	// The refactored version is more readable and easier to understand
	// The refactored version is also more maintainable
	// TODO Test the refactored version to ensure it works as expected, before implementing it in the application
	createBarcodeStream2(): Observable<string> {
		const isShiftKey = (key: string) => key.toLowerCase() === 'shift';
		const isPrefixKey = (key: string) => key === this.barcodePrefixCharacter;
		const isSuffixKey = (key: string) => key === this.barcodeSuffixCharacter;

		const accumulator = (acc: { capturing: boolean; keys: string }, { key }: KeyboardEvent) => {
			if (isPrefixKey(key) && !acc.capturing) {
				return { capturing: true, keys: '' };
			}

			if (isSuffixKey(key) && acc.capturing) {
				return { capturing: false, keys: acc.keys };
			}

			if (acc.capturing) {
				return { capturing: true, keys: acc.keys + key };
			}

			return acc;
		};

		return fromEvent<KeyboardEvent>(window, 'keydown').pipe(
			filter(e => !(e.target instanceof HTMLInputElement) && !isShiftKey(e.key)),
			scan(accumulator, { capturing: false, keys: '' }),
			filter(({ capturing }) => !capturing),
			map(acc => acc.keys),
		);
	}
}
